import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-7585b1cc"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "inner-container"
};
var _hoisted_2 = ["height", "src"];
var _hoisted_3 = /*#__PURE__*/_createTextVNode("退出");
var _hoisted_4 = /*#__PURE__*/_createTextVNode("登录");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_avatar = _resolveComponent("a-avatar");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_menu_item = _resolveComponent("a-menu-item");
  var _component_a_menu = _resolveComponent("a-menu");
  var _component_a_dropdown = _resolveComponent("a-dropdown");
  var _component_a_space = _resolveComponent("a-space");
  var _component_a_row = _resolveComponent("a-row");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["home-header-container", {
      'theme-blue': _ctx.isBlueTheme
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_row, {
    type: "flex",
    align: "middle",
    wrap: false
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        flex: "222px"
      }, {
        default: _withCtx(function () {
          return [!_ctx.hideLogo ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            height: _ctx.HetaoLogoHeight,
            src: _ctx.HetaoLogoFinal,
            alt: "logo"
          }, null, 8, _hoisted_2)) : _createCommentVNode("", true)];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        flex: "auto"
      }), _createVNode(_component_a_col, {
        flex: "222px",
        class: "text-right"
      }, {
        default: _withCtx(function () {
          return [!_ctx.hideAvatar ? (_openBlock(), _createBlock(_component_a_space, {
            key: 0,
            size: 16
          }, {
            default: _withCtx(function () {
              return [_ctx.userService.user && _ctx.userService.user.avatar ? (_openBlock(), _createBlock(_component_a_dropdown, {
                key: 0,
                placement: "bottomCenter"
              }, {
                overlay: _withCtx(function () {
                  return [_createVNode(_component_a_menu, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_a_menu_item, null, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_a_button, {
                            class: "btn-user-center",
                            type: "text",
                            onClick: _ctx.logout,
                            block: ""
                          }, {
                            default: _withCtx(function () {
                              return [_hoisted_3];
                            }),
                            _: 1
                          }, 8, ["onClick"])];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                default: _withCtx(function () {
                  return [_createElementVNode("div", null, [_createVNode(_component_a_avatar, {
                    class: "avatar",
                    size: "large",
                    src: _ctx.HetaoDefaultAvatar,
                    alt: "avatar"
                  }, null, 8, ["src"])])];
                }),
                _: 1
              })) : (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                onClick: _ctx.goLoginPage,
                rel: "noopener",
                type: "primary",
                shape: "round",
                class: "btn-login"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_4];
                }),
                _: 1
              }, 8, ["onClick"]))];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      })];
    }),
    _: 1
  })])], 2);
}